"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestUrlBuilder = void 0;
const react_1 = require("react");
const helpers_1 = require("./helpers");
const TokenAuthContext_1 = __importDefault(require("./TokenAuthContext"));
const useMakeAuth_1 = require("./useMakeAuth");
const useRequestUrlBuilder = () => {
    const { baseURL, setIsSignout } = react_1.useContext(TokenAuthContext_1.default);
    const makeAuth = useMakeAuth_1.useMakeAuth({
        url: baseURL,
        onAuthenticationFailed: () => setIsSignout(true),
    });
    const requestUrlBuilder = (callType, { useAuthJson = true, params = '', useLastToken = false } = {
        useAuthJson: true,
        useLastToken: false,
        params: '',
    }) => {
        return new Promise(async (resolve) => {
            if (useAuthJson) {
                var authToken = await makeAuth(useLastToken);
            }
            const requestAddress = helpers_1.urlBuilder({ baseAddress: baseURL, callType, params, authJson: authToken });
            resolve(requestAddress);
        });
    };
    return requestUrlBuilder;
};
exports.useRequestUrlBuilder = useRequestUrlBuilder;
